import React, {useEffect, useState} from 'react';
import '../assets/scss/webinar.scss';
import ReactPlayer from 'react-player';
import {useHistory, useParams} from 'react-router';
import {CaretRightOutlined, RightOutlined} from '@ant-design/icons';
import {Input, Tooltip} from 'antd';
import Chats from '../components/Chats';
import {forumDiscussionService} from '../services/apiServices';
import {askForumQuestionAutoService, getWebinarService, webinarSessionService} from '../services/oclive';
import {useSelector} from 'react-redux';
import LogoSmall from '../assets/images/docpro-icon.png';
import {isAuthenticated} from '../utilities';
import {isMobile} from 'react-device-detect';
import CourseRatings from '../components/CourseRatings';
import {DefaultProfileIcon} from '../utilities/resources';
import MetaDecorators from '../components/MetaDecorators';
import ModeratorUserSocket from "./moderator/moderatorUserSocket";

function infoTextInitiate(text) {
    const helpObj = {
        assigneeName: 'Omnicuris',
        userProfileUrl: LogoSmall,
        question: text,
        assigneeId: '',
    };
    return helpObj;
}

function OCLiveStream() {
    const {userDetails} = useSelector((state) => state.profile);
    const [questionAsked, setQuestionAsked] = useState([]);
    const [toggleChatSection, setToggleChatSection] = useState(false);
    const [webinarDetails, setWebinarDetails] = useState({});
    const [questionStr, setQuestionStr] = useState('');
    const [showReviewPopup, setShowReviewPopup] = useState({id: undefined, show: false});
    const {youtubeId, chapterId} = useParams();
    const history = useHistory();

    const footer = document.getElementById('footer');

    useEffect(() => {
        setQuestionAsked([]);
        fetchForumDiscussion();
        const header = document.getElementById('header');
        if (history.location.pathname.includes('/stream')) {
            if (header) {
                header.style.display = 'none';
            }
        }
        fetchWebinarDetails();
        const webinarSessionInterval = setInterval(() => {
            webinarSession(chapterId);
        }, 120000);
        return () => {
            if (header) {
                header.style.display = 'unset';
            }
            clearInterval(webinarSessionInterval);
        };
    }, []);

    useEffect(() => {
        if (footer) {
            footer.style.display = 'none';
        }
        return () => {
            if (footer) {
                footer.style.display = 'unset';
            }
        };
    }, [footer]);

    const fetchWebinarDetails = () => {
        getWebinarService(chapterId)
            .then((response) => {
                setWebinarDetails(response.webinar);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const fetchForumDiscussion = () => {
        forumDiscussionService(chapterId)
            .then((response) => {
                if (response.questionAsked.length < 0) {
                    setTimeout(() => {
                        setQuestionAsked([...questionAsked, infoTextInitiate('How may I help you?')]);
                    }, 3000);
                } else {
                    setQuestionAsked(response.questionAsked);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const webinarSession = (chapterId) => {
        const userId = localStorage.getItem('userId');
        if (userId !== null) {
            webinarSessionService(userId, chapterId)
                .then((res) => {
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    const handleChange = (ev) => {
        setQuestionStr(ev.target.value);
    };

    const handleSubmit = () => {
        sendQuestion();
    };

    const handleEnterKey = (ev) => {
        if (ev.keyCode === 13) {
            sendQuestion();
        }
    };

    const handleCloseReviewPopup = (e) => {
        setShowReviewPopup({...showReviewPopup, id: chapterId, show: false});
        returnToWebinarLandingPage();
    };

    const sendQuestion = () => {
        if (questionStr !== '') {
            const userId = userDetails.users && userDetails.users.id;
            const userName = userDetails.users && `${userDetails.users.firstName} ${userDetails.users.lastName}`;
            const profilePic = userDetails.users && userDetails.users.profilePic;
            const accessToken = userDetails.users && userDetails.users.accessToken;
            const questionAskedObj = {
                userName: userName,
                userProfileUrl: profilePic,
                question: questionStr.trim(),
                userId: userId,
            };
            setQuestionAsked((prev) => [...prev, questionAskedObj]);
            setQuestionStr('');
            setTimeout(() => {
                setQuestionAsked((prev) => [...prev, infoTextInitiate('Your message has been sent to the doctor')]);
            }, 3000);
            const payload = {
                accessToken: accessToken,
                expertId: webinarDetails && webinarDetails.experts && webinarDetails.experts.length > 0 ? webinarDetails.experts[0].id : userId,
                chapterId: parseInt(chapterId),
                question: questionStr.trim(),
                autoAssign: true,
                sendSms: false,
            };
            askForumQuestionAutoService(payload)
                .then((response) => {
                    fetchForumDiscussion();
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    const config = {
        youtube: {
            playerVars: {showinfo: 1, fs: 0},
        },
        file: {
            attributes: {
                controlsList: 'nodownload',
                disablePictureInPicture: true
            }
        }
    };

    const chatBoxElements = (
        <>
            <div className={'chatSectionBody'}>
                {userDetails &&
                    userDetails.users &&
                    userDetails.users.id &&
                    questionAsked.map((items, index) => {
                        return (
                            <Chats
                                key={index}
                                id={items.userId}
                                name={items.userName}
                                profilePic={items.userProfileUrl ? items.userProfileUrl : DefaultProfileIcon}
                                question={items.question}
                                userId={userDetails.users && userDetails.users.id}
                            />
                        );
                    })}
            </div>
            {!isMobile && (
                <Tooltip title={toggleChatSection ? 'Ask a question' : ''} placement='left'>
                    <button onClick={() => setToggleChatSection(!toggleChatSection)}
                            className={`collapseChatButton ${toggleChatSection ? 'expandChatButton' : ''}`}>
                        <RightOutlined/>
                    </button>
                </Tooltip>
            )}
            <div className={'chatInputBox'}>
                <Input type='text' value={questionStr} placeholder='Type your comment / question here...'
                       onChange={handleChange} onKeyDown={handleEnterKey}/>
                <button onClick={handleSubmit} className={'chatSubmitButton'}>
                    <CaretRightOutlined/>
                </button>
            </div>
        </>
    );

    const returnToWebinarLandingPage = () => {
        history.push(`/live/${chapterId}`);
    };

    return (
        <div className={'ocLiveStreamLayout'}>
            <MetaDecorators/>
            <div id='video' className={'videoSection'}>
                <ReactPlayer url={`https://www.youtube.com/watch?v=${youtubeId}`} playsinline={true} controls={true}
                             height='100%' width='100%' config={config}/>
                {isMobile ? null : (
                    <button className={'leaveButton'} onClick={() => (isAuthenticated() ? setShowReviewPopup({
                        ...showReviewPopup,
                        id: chapterId,
                        show: true
                    }) : returnToWebinarLandingPage())}>
                        Leave Webinar
                    </button>
                )}
            </div>
            <div id='chat' className={`chatSection ${toggleChatSection ? 'chatSectionCollapse' : ''}`}>
                {chatBoxElements}
            </div>
            <div id='chatMobile'
                 className={`chatSectionMobile ${toggleChatSection ? 'chatSectionMobileCollapse' : ''}`}>
                {chatBoxElements}
            </div>
            {webinarDetails?.moderatorProjectId ?
                <ModeratorUserSocket projectId={webinarDetails.moderatorProjectId}/> : ""}
            {/* <div className='review-popup_wrapper' style={showReviewPopup.id === chapterId && showReviewPopup.show ? { display: 'flex' } : { display: 'none' }}>
        <div className='review-popup'>
          <h3>Rate the webinar </h3>
          <p>Your feedback will help us to improve the platform further</p>
          <CloseCircleFilled onClick={handleCloseReviewPopup} className='review-popup-close' />
          <Rate onChange={starChange} value={rating} />
          <TextArea type='textarea' value={comment} autoSize={{ minRows: 2, maxRows: 3 }} placeholder='Type your comment here...' allowClear onChange={(ev) => handleComment(ev.target.value)} />
          <div className='review-buttons'>
            <button onClick={handleCloseReviewPopup} className='review-button review-button-cancel'>
              Close
            </button>
            <button onClick={handleSubmitReview} disabled={rating === 0} className='review-button review-button-submit'>
              Submit
            </button>
          </div>
        </div>
      </div> */}
            <CourseRatings
                showPopup={showReviewPopup.id === chapterId && showReviewPopup.show}
                closePopup={handleCloseReviewPopup}
                ratingFor='webinar'
                productType='WEBINAR'
                payloads={{widgetType: 'CHAPTER', widgetId: chapterId}}
            />
        </div>
    );
}

export default OCLiveStream;
